
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiMotionTmResetProposal2 as ObiMotionTmResetProposal2Element} from '@oicl/openbridge-webcomponents/dist/icons/icon-motion-tm-reset-proposal-2.js';
 
 
 

 
 export const ObiMotionTmResetProposal2 = createComponent({
   react: React,
   tagName: 'obi-motion-tm-reset-proposal-2',
   elementClass: ObiMotionTmResetProposal2Element,
   events: {
     
   }
  });
 
 